function cov_11ycoazp6o() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/AccountFormSubHeader.tsx";
  var hash = "01fdef5791b7f71e38c333aec32de7e4993a8a81";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/AccountFormSubHeader.tsx",
    statementMap: {
      "0": {
        start: {
          line: 18,
          column: 67
        },
        end: {
          line: 54,
          column: 1
        }
      },
      "1": {
        start: {
          line: 28,
          column: 21
        },
        end: {
          line: 28,
          column: 65
        }
      },
      "2": {
        start: {
          line: 29,
          column: 24
        },
        end: {
          line: 29,
          column: 83
        }
      },
      "3": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 53,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 18,
            column: 67
          },
          end: {
            line: 18,
            column: 68
          }
        },
        loc: {
          start: {
            line: 27,
            column: 6
          },
          end: {
            line: 54,
            column: 1
          }
        },
        line: 27
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 28,
            column: 21
          },
          end: {
            line: 28,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 28,
            column: 34
          },
          end: {
            line: 28,
            column: 48
          }
        }, {
          start: {
            line: 28,
            column: 51
          },
          end: {
            line: 28,
            column: 65
          }
        }],
        line: 28
      },
      "1": {
        loc: {
          start: {
            line: 29,
            column: 24
          },
          end: {
            line: 29,
            column: 83
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 29,
            column: 37
          },
          end: {
            line: 29,
            column: 62
          }
        }, {
          start: {
            line: 29,
            column: 65
          },
          end: {
            line: 29,
            column: 83
          }
        }],
        line: 29
      },
      "2": {
        loc: {
          start: {
            line: 33,
            column: 7
          },
          end: {
            line: 37,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 33,
            column: 7
          },
          end: {
            line: 33,
            column: 20
          }
        }, {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 36,
            column: 15
          }
        }],
        line: 33
      },
      "3": {
        loc: {
          start: {
            line: 38,
            column: 7
          },
          end: {
            line: 51,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 38,
            column: 7
          },
          end: {
            line: 38,
            column: 24
          }
        }, {
          start: {
            line: 38,
            column: 28
          },
          end: {
            line: 38,
            column: 46
          }
        }, {
          start: {
            line: 38,
            column: 50
          },
          end: {
            line: 38,
            column: 73
          }
        }, {
          start: {
            line: 39,
            column: 8
          },
          end: {
            line: 50,
            column: 15
          }
        }],
        line: 38
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "01fdef5791b7f71e38c333aec32de7e4993a8a81"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_11ycoazp6o = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_11ycoazp6o();
import React from 'react';
import { Box, Link, Text } from '@opendoor/bricks-next';
import { t } from "../../i18n/translationHelper.mjs";
cov_11ycoazp6o().s[0]++;
var AccountFormSubHeader = function AccountFormSubHeader(_ref) {
  var loginSubHeaderText = _ref.loginSubHeaderText,
    registrationSubHeaderText = _ref.registrationSubHeaderText,
    email = _ref.email,
    onValidEmailReset = _ref.onValidEmailReset,
    hasSubmittedEmail = _ref.hasSubmittedEmail,
    isNewHuman = _ref.isNewHuman,
    hidePasswordField = _ref.hidePasswordField,
    phoneNumberInputHidden = _ref.phoneNumberInputHidden;
  cov_11ycoazp6o().f[0]++;
  var actionText = (cov_11ycoazp6o().s[1]++, isNewHuman ? (cov_11ycoazp6o().b[0][0]++, t('signingUp')) : (cov_11ycoazp6o().b[0][1]++, t('signingIn')));
  var subHeaderText = (cov_11ycoazp6o().s[2]++, isNewHuman ? (cov_11ycoazp6o().b[1][0]++, registrationSubHeaderText) : (cov_11ycoazp6o().b[1][1]++, loginSubHeaderText));
  cov_11ycoazp6o().s[3]++;
  return /*#__PURE__*/React.createElement(Box, null, (cov_11ycoazp6o().b[2][0]++, subHeaderText) && (cov_11ycoazp6o().b[2][1]++, /*#__PURE__*/React.createElement(Text, {
    typography: "$subheaderSmall",
    marginTop: "$5x",
    marginBottom: "$5x",
    tag: "h2"
  }, subHeaderText)), (cov_11ycoazp6o().b[3][0]++, hasSubmittedEmail) && (cov_11ycoazp6o().b[3][1]++, !hidePasswordField) && (cov_11ycoazp6o().b[3][2]++, !phoneNumberInputHidden) && (cov_11ycoazp6o().b[3][3]++, /*#__PURE__*/React.createElement(Text, {
    typography: "$bodySmall",
    tag: "p",
    gap: "$2x"
  }, actionText, " as", ' ', /*#__PURE__*/React.createElement(Link, {
    href: "_",
    size: "small",
    variant: "secondary",
    analyticsName: "Reset email",
    onPress: onValidEmailReset
  }, email))));
};
export default AccountFormSubHeader;
//# sourceMappingURL=AccountFormSubHeader.mjs.map